import { BrainCircuit } from 'lucide-react';

export default function LegalLayout({ children }) {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-indigo-500/30">
      <nav className="fixed w-full z-50 bg-slate-950/80 backdrop-blur-md border-b border-slate-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 text-indigo-400">
            <BrainCircuit size={28} />
            <span className="font-bold text-xl tracking-tight text-white">Sink</span>
          </a>
          <a href="/" className="text-sm font-medium text-slate-400 hover:text-white transition">
            ホームに戻る
          </a>
        </div>
      </nav>

      <main className="pt-24 pb-16 px-6">
        <div className="max-w-3xl mx-auto prose prose-invert prose-slate">
          {children}
        </div>
      </main>

      <footer className="bg-slate-950 py-12 border-t border-slate-800">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <div className="text-sm text-slate-500">
            &copy; 2026 Sink. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}
